import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolders12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFolders12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Folders12)">
                    <path
                        fill="currentColor"
                        d="M6.022 0a1 1 0 0 1 .854.479L7.806 2H10.5A1.5 1.5 0 0 1 12 3.5v4A1.5 1.5 0 0 1 10.5 9H10v1.5A1.5 1.5 0 0 1 8.5 12h-7A1.5 1.5 0 0 1 0 10.5V4a1 1 0 0 1 1-1h1V1a1 1 0 0 1 1-1zM1 10.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H1zM4.022 3a1 1 0 0 1 .854.479L5.806 5H8.5A1.5 1.5 0 0 1 10 6.5V8h.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5zM1 5h3.634l-.612-1H1zm2-3h3.634l-.612-1H3z"
                    />
                </g>
                <defs>
                    <clipPath id="Folders12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFolders12);
